// oxlint-disable-next-line endla/no-compiler-opt-out -- Existing code
"use no memo";

export const LOGIN_URL = "/login";
export const DEVICE_LOGIN_URL = "/login/device";
export const LOGOUT_URL = "/logout";
export const PASSWORD_RESET_URL = "/password-reset";
export const ACCOUNT_SETTINGS_URL = "/account-settings";

export const DEEP_INSIGHT_URL = "/deep-insight";
export const PIPELINES_URL = "/gathering-network";
export const TALLY_DESIGN_URL = "/tally-design";
export const FRAC_DESIGN_URL = "/frac";
export const WELL_PATH_DESIGN_URL = "/well-path-design";

export const DEEP_INSIGHT_URL_CYPRESS_VIEW = `${DEEP_INSIGHT_URL}?loadView=Cypress`;

export const TALLY_DESIGN = Object.freeze({
  DASHBOARD_URL: "dashboard",
  DATA_URL: "data",
  TALLY_DESIGN_URL: "tally-design",
  DIAGRAM: "diagram/:tally_design_pk",
});

export const DATA_HUB = Object.freeze({
  WELL_AS_BUILTS_URL: "well-as-builts",
  TALLY_DESIGN_WORKFLOWS_URL: "tally-design-workflows",
  TALLY_DESIGN_TASKS_URL: "tally-design-tasks",
});

export const TALLY_DESIGN_TASK_URL = `/${TALLY_DESIGN.TALLY_DESIGN_URL}/${TALLY_DESIGN.DATA_URL}/${DATA_HUB.TALLY_DESIGN_TASKS_URL}/:tally_design_task_pk`;

export const TALLY_DESIGN_DASHBOARD = Object.freeze({
  WELL_VIEW_URL: "/dashboard/well-view",
  CASING_TALLY_URL: "/dashboard/casing-tally",
  PART_ANALYSIS_URL: "/dashboard/part-analysis",
  LITHOLOGY_ANALYSIS_URL: "/dashboard/lithology-analysis",
  COMPARE_COMPLETIONS_URL: "/dashboard/compare-completions",
  COMPARE_INPUT_SHEETS_URL: "/dashboard/compare-input-sheets",
});

export const GATHERING_NETWORK_URL = "/gathering-network";
export const LITHOLOGY_INTERPRETATION_URL = "/lithology";

export const FRAC_DESIGN = Object.freeze({
  URL: "frac",
  FRAC_DESIGN_URL: "design",
  STAGE_DESIGNS: "stage-designs",
  SPECIFICATIONS: "design-specifications",
  DATA_URL: "data",
});
